/**
 * @fileoverview GET handler for the "/data_objects/:type_name/:external_id/unlinked_objects" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameExternalIdUnlinkedObjects } from "./constants";
import type {
  CustomObjectsTypeNameExternalIdUnlinkedObjectsParams,
  CustomObjectsTypeNameExternalIdUnlinkedObjectsResponse,
} from "./types";
import { isCustomObjectsTypeNameExternalIdUnlinkedObjectsResponse } from "./validators";

export const getCustomObjectsTypeNameExternalIdUnlinkedObjects = reactQueryFetcherAdapter(
  customObjectsTypeNameExternalIdUnlinkedObjects,
  (
    signal: AbortSignal,
    {
      appGroupId,
      typeName,
      externalId,
      relKind,
      direction,
      targetTypeName,
      searchTerm,
      start = 0,
      limit = 12,
    }: CustomObjectsTypeNameExternalIdUnlinkedObjectsParams
  ): Promise<CustomObjectsTypeNameExternalIdUnlinkedObjectsResponse> => {
    // The backend contract guarantees zero rows for a blank search term, so skip the request
    // (typeahead consumers mount with an empty term before the user types).
    if (searchTerm.trim() === "") {
      return Promise.resolve({ hits: 0, results: [] });
    }

    return fetch<CustomObjectsTypeNameExternalIdUnlinkedObjectsResponse>(
      `/data_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(externalId)}/unlinked_objects`,
      "GET",
      {
        app_group_id: appGroupId,
        rel_kind: relKind,
        direction,
        target_type_name: targetTypeName,
        search_term: searchTerm,
        start,
        limit,
      },
      { signal }
    );
  },
  isCustomObjectsTypeNameExternalIdUnlinkedObjectsResponse
);
